<h1>App Colors</h1>

<div class="color-container primary-color">
  <div class="text__white">Here is some white text.</div>
  <div class="text__black">Here is some black text.</div>
  <div class="variations-container">
    <div class="third primary-color">$primary-color</div>
    <div class="third primary-color-light">light-color($primary-color)</div>
    <div class="third primary-color-lighter">lighter-color($primary-color)</div>
    <div class="clearfix"></div>
  </div>
</div>

<div class="color-container secondary-color">
  <div class="text__white">Here is some white text.</div>
  <div class="text__black">Here is some black text.</div>
  <div class="variations-container">
    <div class="third secondary-color">$secondary-color</div>
    <div class="third secondary-color-light">light-color($secondary-color)</div>
    <div class="third secondary-color-lighter">lighter-color($secondary-color)</div>
    <div class="clearfix"></div>
  </div>
</div>

<div class="color-container accent-yellow">
  <div class="text__white">Here is some white text.</div>
  <div class="text__black">Here is some black text.</div>
  <div class="variations-container">
    <div class="third accent-yellow">$accent-yellow</div>
    <div class="third accent-yellow-light">light-color($accent-yellow)</div>
    <div class="third accent-yellow-lighter">lighter-color($accent-yellow)</div>
    <div class="clearfix"></div>
  </div>
</div>

<div class="color-container accent-blue">
  <div class="text__white">Here is some white text.</div>
  <div class="text__black">Here is some black text.</div>
  <div class="variations-container">
    <div class="third accent-blue">$accent-blue</div>
    <div class="third accent-blue-light">light-color($accent-blue)</div>
    <div class="third accent-blue-lighter">lighter-color($accent-blue)</div>
    <div class="clearfix"></div>
  </div>
</div>

<div class="color-container accent-dark-grey">
  <div class="text__white">Here is some white text.</div>
  <div class="text__black">Here is some black text.</div>
  <div class="variations-container">
    <div class="third accent-dark-grey">$accent-dark-grey</div>
    <div class="third accent-dark-grey-light">light-color($accent-dark-grey)</div>
    <div class="third accent-dark-grey-lighter">lighter-color($accent-dark-grey)</div>
    <div class="clearfix"></div>
  </div>
</div>

<div class="color-container accent-medium-grey">
  <div class="text__white">Here is some white text.</div>
  <div class="text__black">Here is some black text.</div>
  <div class="variations-container">
    <div class="third accent-medium-grey">$accent-medium-grey</div>
    <div class="third accent-medium-grey-light">light-color($accent-medium-grey)</div>
    <div class="third accent-medium-grey-lighter">lighter-color($accent-medium-grey)</div>
    <div class="clearfix"></div>
  </div>
</div>

<div class="color-container accent-light-grey">
  <div class="text__white">Here is some white text.</div>
  <div class="text__black">Here is some black text.</div>
  <div class="variations-container">
    <div class="third accent-light-grey">$accent-light-grey</div>
    <div class="third accent-light-grey-light">light-color($accent-light-grey)</div>
    <div class="third accent-light-grey-lighter">lighter-color($accent-light-grey)</div>
    <div class="clearfix"></div>
  </div>
</div>